import { MutationTree } from "vuex";

import { SystemSettingsState } from "@/models/SystemSettingsState";
import Vue from "vue";

export const mutations: MutationTree<SystemSettingsState> = {
  setSystemSettingsData(state: SystemSettingsState, systemSettingsData) {
    Vue.set(
      state,
      "userManualVideoEnabled",
      systemSettingsData.enable_user_manual_video
    );
    Vue.set(state, "userHelpButtonEnabled", systemSettingsData.enable_help);
    // Vue.set(state, 'enableRegisteration', systemSettingsData.enable_registration);
    // Vue.set(state, 'enableAutoEnrollment', systemSettingsData.auto_enroll_users);
  }
};
